import React, { createContext, useContext, useState } from 'react';

import { urlConfig } from '../../config/urlConfig';
import { accessTokenRequest, sendRequest } from '../global/global.service';
import { ProfileContext } from '../profile/profile.context';

export const PreferLocationContext = createContext();

export const PreferLocationContextProvider = ({ children }) => {
  const { user } = useContext(ProfileContext)
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const [saveLocationLoading, setSaveLocationLoading] = useState(false);
  const [findLocationLoading, setFindLocationLoading] = useState(false);
  const [locationSelected, setLocationSelected] = useState(false);
  const [type, setType] = useState(null);
  const [place, setPlace] = useState(null);
  const [fetchUserLocation, setFetchUserLocation] = useState(true);
  const [preferLocation, setPreferLocation] = useState(null);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      setOpen(false);
    }
    setOpen(false);
  };

  const getUserPreferLocation = (map) => {
    accessTokenRequest()
      .then((response) => {
        sendRequest(
          `${urlConfig.user_prefer_location}`,
          response,
          'get',
          null
        )
          .then((res) => {
            if (res.data && res.data.places) {
              setPreferLocation(res.data.places.at(-1));
              map.setView([
                res.data.places.at(-1).lat,
                res.data.places.at(-1).lng,
              ]);
            }
            setFetchUserLocation(false);
          })
          .catch((err) => {
            console.log({ err });
            setFetchUserLocation(false);
          });
      })
      .catch((err) => {
        console.log({ err });
        setFetchUserLocation(false);
      });
  };

  const savePreferLocation = () => {
    if (locationSelected) {
      setSaveLocationLoading(true);
      accessTokenRequest()
        .then((response) => {
          sendRequest(
            urlConfig.user_prefer_location,
            response,
            'post',
            locationSelected
          )
            .then((res) => {
              setOpen(true);
              setSaveLocationLoading(false);
              setPlace(null);
              setFetchUserLocation(true);
            })
            .catch((err) => {
              console.log(`err`, err);
              setSaveLocationLoading(false);
              setError(err.toString());
            });
        })
        .catch((err) => {
          console.log(`err`, err);
          setSaveLocationLoading(false);
          setError(err.toString());
        });
    } else {
      setError('Please select place!');
    }
  };

  return (
    <PreferLocationContext.Provider
      value={{
        open,
        error,
        type,
        saveLocationLoading,
        findLocationLoading,
        place,
        preferLocation,
        fetchUserLocation,
        getUserPreferLocation,
        setPlace,
        setLocationSelected,
        setFindLocationLoading,
        setType,
        savePreferLocation,
        handleClose,
      }}
    >
      {children}
    </PreferLocationContext.Provider>
  );
};
